// initial search transaction data
export const initialSearchSalesPayment = {
  from_date: null,
  to_date: null,
  sales_payment_no: '',
  customer_name_container: null,
  customer_name: '',
};
